import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getProcessInfo() {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/admin/dashboard/process-info", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process info"
                    });
                }
            });
    },
    getTaskData() {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/admin/dashboard/task-info", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching task info"
                    });
                }
            });
    },
    getUserProcessInfo() {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/dashboard/user-process-info", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process info"
                    });
                }
            });
    }
    ,
    getUserTaskInfo() {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/dashboard/user-task-info", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching task info"
                    });
                }
            });
    }
}
